
const ROOT = '/zone-management'

const zoneManagementPaths = {
  root: ROOT,
  addRole: `${ROOT}/add-zone`,
};

export default zoneManagementPaths;
